import * as React from 'react';
import { connect } from 'react-redux';
import { ControlConfig } from '../components';
import store from '../store/store';
import types from '../store/types';
import {
    PropertyHelper, getControlTemplate, IControl, IdHelper, clone, ControlHelper, EModalType, ModalHelper, IOutputValue, OutputsHelper, IProperty,
    IValidationConfig, QueryBuilderHelper, IValidationMessage, IErrorMessage, ComponentHelper, IValidationResponse, IComponent, EConfirmationOperationType, ActionHelper
} from '../helpers';
import { VALIDATION_UNSAVED_CONTROL_ERROR } from '../constants';
import { Promise } from 'es6-promise';
import { IDropdownOption } from 'office-ui-fabric-react';

declare var $;
interface IProps {
    showBlockContent?: boolean;
    changeShowBlockContent?: (val: boolean) => void;
    changeCurrentControlIndex?: (val: number) => void;
    showBlockTabs?: boolean;
    changeShowBlockTabs?: (val: boolean) => void;
    changeShowNewBlock?: (val: boolean, val2?: boolean) => void;
    isNewBlock?: boolean;
    controls?: IControl;
    addNewLayoutPanel?: (componentId: string) => void;
}

class ControlConfigContainer extends React.Component<any, IProps, any> {
    private option: any;
    constructor(props: any) {
        super(props);
        this.changeShowBlockContent = this.changeShowBlockContent.bind(this);
        this.changeShowBlockTabs = this.changeShowBlockTabs.bind(this);

    }
    changeShowBlockContent(val: boolean) {
        const newShowBlockContent = this.props.showBlockContent;
        this.props.changeShowBlockContent(val);
    }
    changeShowBlockTabs() {
        const newShowBlockContent = this.props.showBlockTabs;
        this.props.changeShowBlockTabs(true);
    }

    updateProperty = (key: string, value: any) => {

        let previousLabel = PropertyHelper.getPropertyValue(this.props.state.control.Properties, 'Label');
        let control = PropertyHelper.updateProperty(this.props.state.control, key, value);

        if (control.OutputValues) {
            let primaryOutput = control.OutputValues[0];

            if (key === 'Type')
                control.type = value;

            if (key === 'Label' && ControlHelper.shouldOverwriteOutputName(primaryOutput.Name, previousLabel)) {

                control.OutputValues.forEach((x: IOutputValue) => {
                    x.Name = value + " - " + x.StaticName;
                });

                control.OutputValues[0].Name = value;
            }

        }

        if (key === 'Entity Name') {
            this.loadEntityFields(value, this.props.state.componentId)
        }

        store.dispatch({
            type: types.UPDATE_CONTROL_DIALOG,
            control: control
        });
    }

    showPivotErrorMessage = () => {

        if ($(".ms-Pivot-link.is-selected").length) {
            let activePivotItem = $(".ms-Pivot-link.is-selected").find('.ms-Pivot-text').text();
            let errorMessage: string = '';

            switch (activePivotItem) {
                case 'Validation':
                    errorMessage = VALIDATION_UNSAVED_CONTROL_ERROR
                    break;
                default:
                    errorMessage = 'Please ensure all query builder properties contain valid queries';
                    break;
            }

            store.dispatch({
                type: types.SET_MODAL_ERROR_MESSAGES,
                errorMessages: [errorMessage]
            });
            ModalHelper.scrollToErrorDisplay();

        }

    }

    closeDialog = (save?: boolean, optionsDefinedByJSON?: boolean, isNewControl?: boolean) => {

        // store.getState().modalState.controlConfig.controlIndex = 2;

        let { state, isSharedJourney, parentLoopId, controls, changeCurrentControlIndex } = this.props;

        if (save) {

            if (QueryBuilderHelper.canSaveQueryEditor()) {

                let valueOptionsProperty: IProperty = state.control.Properties ? state.control.Properties.filter(prop => prop.Name === 'Value Options')[0] : null;
                let styleProperty: IProperty = state.control.Properties ? state.control.Properties.filter(prop => prop.Name === 'Style')[0] : null;

                if (optionsDefinedByJSON) {
                    //clear the list of options property
                    if (valueOptionsProperty) {
                        valueOptionsProperty.ValueOptions = [];
                    }
                }

                //clear the imageUrl in ValueOptions if the style is not Tick Box or Radio Buttons
                if (valueOptionsProperty && valueOptionsProperty.ValueOptions &&
                    !(styleProperty.Value && styleProperty.Value.length &&
                        (styleProperty.Value === 'TickBox' || styleProperty.Value === 'RadioButtons'))
                ) {
                    valueOptionsProperty.ValueOptions = valueOptionsProperty.ValueOptions.map(v => {
                        v.imageUrl = '';
                        return v;
                    });
                }

                let errorMessages: string[] = this.getErrorMessages(optionsDefinedByJSON);

                if (errorMessages.length) {

                    store.dispatch({
                        type: types.SET_MODAL_ERROR_MESSAGES,
                        errorMessages: errorMessages
                    });

                    //scroll to the top of the dialog so that the error message is visible
                    ModalHelper.scrollToErrorDisplay();

                }
                else {

                    // get label of the control
                    const controlLabel = state.control.Properties.filter(x => x.Name === 'Label')[0].Value;

                    // set prefix to the control outputs
                    state.control.OutputValues && state.control.OutputValues.forEach(element => {
                        element.Name = element.StaticName + ' - ' + controlLabel;
                    });

                    ComponentHelper.validateComponentProperties(state.control.ControlType.NameType, state.componentId, state.control.Properties, state.control.OutputValues, null).then(
                        (validationResponse: IValidationResponse) => {

                            let errorMessages: string[] = validationResponse.errorMessages.map((e) => e.clientErrorMessage);
                            let warningMessages: string[] = validationResponse.warningMessages.map((w) => w.clientErrorMessage)

                            if (errorMessages.length || warningMessages.length) {
                                store.dispatch({
                                    type: types.SET_MODAL_ERROR_MESSAGES,
                                    errorMessages: errorMessages
                                });
                                store.dispatch({
                                    type: types.SET_MODAL_WARNING_MESSAGES,
                                    warningMessages: warningMessages
                                });
                                ModalHelper.scrollToErrorDisplay();
                            }
                            else {

                                //set the isSharedJourneyOutput on all outputs if the journey is a shared one
                                if (isSharedJourney && state.control.OutputValues) {
                                    state.control.OutputValues.forEach(o => {
                                        o.DisplayOnSummary = false;
                                    });
                                }

                                //set the LoopId on all outputs if the control belongs to a control block that is part of a loop
                                if (parentLoopId && state.control.OutputValues) {
                                    state.control.OutputValues.forEach(o => {
                                        o.LoopId = parentLoopId
                                    });
                                }


                                //if the control is Get View, we need to set the value to hidden property
                                let quickCreateFormProperty = state.control.Properties.filter(x => x.Name === "Quick Create Form");
                                if (quickCreateFormProperty.length) {
                                    state.control.Properties.filter(x => x.Name === "Quick Create Form Fields")[0].Value = state.quickForms && JSON.stringify(state.quickForms.filter(y => y.Value === quickCreateFormProperty.value)[0]);
                                }

                                //save the control
                                store.dispatch({
                                    type: types.UPDATE_CONTROL,
                                    componentId: state.componentId,
                                    controlIndex: state.controlIndex,
                                    control: state.control,
                                    parentLoopId: parentLoopId,
                                    layoutPanelIndex: state.layoutPanelIndex
                                });

                                //if its a new block, append it to the very last layout panel
                                isNewControl ?
                                    store.dispatch({
                                        type: types.ADD_CONTROL_TO_LAYOUT_PANEL,
                                        componentId: state.componentId,
                                        control: state.control,
                                        layoutPanelIndex: state.layoutPanelIndex
                                    })
                                    : null;

                                store.dispatch({
                                    type: types.SET_MODAL_ERROR_MESSAGES,
                                    errorMessages: []
                                });

                                store.dispatch({
                                    type: types.SET_MODAL_OVERLAY_MESSAGE,
                                    overlayMessage: 'Success'
                                });
                                setTimeout(() => {

                                    store.dispatch({
                                        type: types.SET_MODAL_OVERLAY_MESSAGE,
                                        overlayMessage: null
                                    });

                                }, 250);

                                let outputsInUse: {} = OutputsHelper.getLatestOutputsInUse();
                                store.dispatch({
                                    type: types.UPDATE_OUTPUTS_IN_USE,
                                    outputsInUse: outputsInUse
                                });

                                isNewControl ?
                                    this.props.changeShowNewBlock(false, false)
                                    :
                                    this.props.changeCurrentControlIndex(-1);

                                //close the modal
                                // store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
                                // store.getState().modalState.controlConfig.controlIndex = 2;
                                // this.props.changeShowNewBlock(false, false);
                                // store.getState().modalState.controlConfig.controlIndex = null;



                            }
                        }
                    );

                }
            }


        }
        else {
            //close the modal anyway
            isNewControl ?
                this.props.changeShowNewBlock(false, false)
                :
                store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

        }

    }

    getErrorMessages = (optionsDefinedByJSON?: boolean): string[] => {
        let errorMessages: string[] = [];
        let control: IControl = this.props.state.control;
        if (control.Properties) {
            let verifyValueOptions: boolean = control.ControlType.NameType === 'List Of Options' || control.ControlType.NameType === 'Multi Select Control';
            errorMessages = errorMessages.concat(PropertyHelper.getErrorMessages(control.Properties, verifyValueOptions, optionsDefinedByJSON));
        }
        if (control.OutputValues) {
            errorMessages = errorMessages.concat(OutputsHelper.getErrorMessages(control.OutputValues));
        }
        return errorMessages;
    }

    deleteControl = () => {

        let { state, parentLoopId } = this.props;

        if (state.control.ControlId.length) {
            store.dispatch({
                type: types.TOGGLE_CONFIRMATION_DIALOG,
                operationType: EConfirmationOperationType.DeleteControl,
                title: 'Confirm Deletion',
                message: 'Are you sure you want to delete this control from the section?',
                isOpen: true,
                okButtonLabel: 'Delete',
                cancelButtonLabel: 'Cancel',
                componentId: state.control.ComponentId,
                controlIndex: state.controlIndex,
                outputs: state.control.OutputValues
            });

            // store.dispatch({
            //     type: types.DELETE_CONTROL,
            //     componentId: state.control.ComponentId,
            //     controlIndex: state.controlIndex,
            //     outputs: state.control.OutputValues
            // });

            // store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
        }

        // store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });

    }

    loadControlTemplate = (key): Promise<any> => {
        var promise = new Promise((resolve, reject) => {
            if (this.props.controlTemplates[key]) {
                resolve(clone(this.props.controlTemplates[key]));
            }
            else {
                getControlTemplate(key).then(
                    (template) => {
                        store.dispatch({
                            type: types.ADD_CONTROL_TEMPLATE,
                            key: key,
                            controlTemplate: template
                        });
                        resolve(template);
                    },
                    (error) => {
                        reject(error);

                    }
                );
            }
        });

        return promise;
    }

    dropdownChange = (item) => {
        this.option = item;

        let { state } = this.props;

        // TODO: apply temporary properties that feature only the type dropdown
        let tempControl: IControl = state.control;
        tempControl.Properties = [];
        tempControl.ControlType.NameType = item.key;

        store.dispatch({
            type: types.UPDATE_CONTROL_DIALOG,
            control: tempControl
        });

        store.dispatch({
            type: types.SET_MODAL_OVERLAY_MESSAGE,
            overlayMessage: 'Loading...'
        });

        this.loadControlTemplate(item.key).then(
            (controlTemplate) => {
                let control: IControl = ControlHelper.createControl(state.control.ComponentId, controlTemplate);

                store.dispatch({
                    type: types.SET_MODAL_ERROR_MESSAGES,
                    errorMessages: []
                });

                store.dispatch({
                    type: types.UPDATE_CONTROL_DIALOG,
                    control: control
                });

                store.dispatch({
                    type: types.SET_MODAL_OVERLAY_MESSAGE,
                    overlayMessage: null
                });
            }
        );


    }

    onLoad = (control: IControl) => {
        if (!control.ControlId.length) {
            // this.dropdownChange(this.props.controlTypes.filter(option => option.key === 'Textbox')[0]);
        }

        //sort out the tab index       
        let typeDropdown = document.querySelector('.pivotItem .ms-Dropdown');
        if (typeDropdown) {
            typeDropdown.setAttribute('tabindex', '1');
        }

        const formEntityNameProp = control.ControlType.NameType.toLowerCase() === 'create form' && control.Properties.filter(x => x.Name.toLowerCase() === 'entity name');
        if (formEntityNameProp && formEntityNameProp.length && formEntityNameProp[0].Value) {
            const entityName = control.Properties.filter(x => x.Name.toLowerCase() === 'entity name') ? control.Properties.filter(x => x.Name.toLowerCase() === 'entity name')[0].Value : null;
            entityName ?
                this.loadEntityForms(entityName) :
                null;
        }

        const viewEntityNameProp = (control.ControlType.NameType.toLowerCase() === 'get view' || control.ControlType.NameType.toLowerCase() === 'datatable') && control.Properties.filter(x => x.Name.toLowerCase() === 'entity name');
        if (viewEntityNameProp && viewEntityNameProp.length && viewEntityNameProp[0].Value) {
            const entityName = control.Properties.filter(x => x.Name.toLowerCase() === 'entity name') ? control.Properties.filter(x => x.Name.toLowerCase() === 'entity name')[0].Value : null;
            if (entityName) {
                this.loadEntityViews(entityName).then(() => {
                    console.log('this.props.state.entityViews -->', this.props.state.entityViews);
                });
                this.loadEntityForms(entityName).then(() => {
                    console.log('this.props.state.entityForms -->', this.props.state.entityForms);
                });
            }
        }

        if (control.ControlType.NameType.toLowerCase() === 'google map')
            ControlHelper.loadCaseServiceTypes();

        if (this.props.isNewBlock)
            ControlHelper.resetAllEntityStateVariables();
    }

    isControlTypeDropdownDisabled = (control: IControl): boolean => {
        return control.ControlId.length > 0;
    }

    isDeleteButtonDisabled = (control: IControl): boolean => {
        return control.ControlId.length === 0;
    }

    updateControlOutput = (index: number, name: string) => {
        store.dispatch({ type: types.UPDATE_CONTROL_OUTPUT, index: index, name: name });
    }

    controlOutputBlur = (index: number, name: string, staticName: string, logicalName: string) => {
        if (!(name || name.length)) {
            let newName = staticName || logicalName;
            this.updateControlOutput(index, newName);
        }
    }

    updateSelectedGlobalOutput = (index: number, key: string) => {
        store.dispatch({
            type: types.UPDATE_CONTROL_GLOBAL_OUTPUT,
            index: index,
            key: key
        });
    }

    updateControlOutputLogicalName = (index: number, logicalName: string) => {
        // Logical name cannot contain spaces. replace with "_";
        logicalName = logicalName.replace(/ /ig, "_");
        // Logical name must only consist of lower case letters, or numbers - toLower()
        logicalName = logicalName.toLowerCase();

        store.dispatch({
            type: types.UPDATE_CONTROL_OUTPUT_LOGICAL_NAME,
            index: index,
            logicalName: logicalName
        });
    }

    updateOutputDefaultValue = (index: number, defaultValue: string) => {
        store.dispatch({
            type: types.UPDATE_CONTROL_OUTPUT_DEFAULT_VALUE,
            index: index,
            defaultValue: defaultValue
        });
    };

    setAdvancedSettingsIndex = (index: number) => {

        index = index !== this.props.state.advancedSettingsIndex ? index : null;

        store.dispatch({
            type: types.UPDATE_CONTROL_ADVANCED_SETTINGS_INDEX,
            advancedSettingsIndex: index
        });
    }

    updateEditedValidationItem = (editedValidationItem: IValidationConfig) => {
        store.dispatch({
            type: types.UPDATE_EDITED_VALIDATION_ITEM,
            editedValidationItem: editedValidationItem
        });
        store.dispatch({
            type: types.SET_MODAL_ERROR_MESSAGES,
            errorMessages: []
        });
    }
    setValidationEditIndex = (validationEditIndex: number) => {
        store.dispatch({
            type: types.SET_VALIDATION_EDIT_INDEX,
            validationEditIndex: validationEditIndex
        });
        store.dispatch({
            type: types.SET_MODAL_ERROR_MESSAGES,
            errorMessages: []
        });
    }

    optionHandler = {
        addOption: () => {
            store.dispatch({ type: types.ADD_CONTROL_OPTION });
        },
        removeOption: (index: number) => {
            store.dispatch({ type: types.REMOVE_CONTROL_OPTION, index: index });
        },
        updateOptionLabel: (index: number, label: string) => {
            store.dispatch({ type: types.UPDATE_CONTROL_OPTION, index: index, key: 'text', value: label });
        },
        updateOptionValue: (index: number, value: string) => {
            store.dispatch({ type: types.UPDATE_CONTROL_OPTION, index: index, key: 'key', value: value });
        },
        updateOptionImageUrl: (index: number, value: string) => {
            store.dispatch({ type: types.UPDATE_CONTROL_OPTION, index: index, key: 'imageUrl', value: value });
        },
        moveOption: (fromIndex: number, toIndex: number) => {
            store.dispatch({ type: types.MOVE_CONTROL_OPTION, fromIndex: fromIndex, toIndex: toIndex });
        }
    };

    itemHandler = {
        addItem: () => {
            store.dispatch({ type: types.ADD_CONTROL_ITEM });
        },
        removeItem: (index: number) => {
            store.dispatch({ type: types.REMOVE_CONTROL_ITEM, index: index });
        },
        updateItemLabel: (index: number, label: string) => {
            store.dispatch({ type: types.UPDATE_CONTROL_ITEM, index: index, key: 'text', value: label });
        },
        updateItemURL: (index: number, value: string) => {
            store.dispatch({ type: types.UPDATE_CONTROL_ITEM, index: index, key: 'url', value: value });
        },
        updateItemIcon: (index: number, value: string) => {
            store.dispatch({ type: types.UPDATE_CONTROL_ITEM, index: index, key: 'icon', value: value });
        },
        moveItem: (fromIndex: number, toIndex: number) => {
            store.dispatch({ type: types.UPDATE_CONTROL_ITEM, fromIndex: fromIndex, toIndex: toIndex });
        }
    };

    // Update properties for action with Create Record option
    changeEntityForm = (key: string, value: any) => {

        store.dispatch({
            type: types.SET_IS_PROPERTY_CHANGED,
            value: true
        });

        let previousLabel = PropertyHelper.getPropertyValue(this.props.state.control.Properties, 'Label');
        let control = PropertyHelper.updateProperty(this.props.state.control, key, value);
        PropertyHelper.resolveAdjustedFields(control.Properties, this.props.propertyFilters, key, value, true);

        if (control.OutputValues) {
            let primaryOutput = control.OutputValues[0];

            if (key === 'Label' && ActionHelper.shouldOverwriteOutputName(primaryOutput.Name, previousLabel)) {
                control.OutputValues[0].Name = value;
            }
        }

        // If the changed value comes from Entity Name field, fetch necessary fields for the selected entity name.
        // Store the fields in the state to update the values in the Fields Name dropdown.
        if (key === 'Entity Name') {

            // set entity form loading to false
            store.dispatch({
                type: types.SET_ARE_ENTITY_FORMS_LOADING,
                value: true
            });

            this.loadEntityForms(value).then(x => {
                // set entity form loading to false
                store.dispatch({
                    type: types.SET_ARE_ENTITY_FORMS_LOADING,
                    value: false
                });

            })
            // this.setEntityOutput(action, value);
        }

        // Update state action along with fieldConfigs
        // store.dispatch({
        //     type: types.UPDATE_ACTION_ENTITY_DIALOG,
        //     action: control
        // });
    }

    // Update properties for action with Create Record option
    changeEntityView = (key: string, value: any) => {
        ControlHelper.changeEntityView(key, value, this.props.state.control, this.props.propertyFilters);
    }
    // Update properties for action with Create Record option
    changeEntityViewColumn = (key: string, value: any = null) => {

        // let test = JSON.parse(this.props.state.entityViews.filter(x => x.key === key)[0].text);
        if (!key) {
            store.dispatch({
                type: types.SET_IS_PROPERTY_CHANGED,
                value: true
            });

            store.dispatch({
                type: types.SET_CONTROL_ENTITY_VIEW_COLUMNS,
                entityViewColumns: null
            });
            return;
        }

        const selectedLayoutView = JSON.parse(this.props.state.entityViews.filter(x => x.key === key)[0].text).layoutjson ?
            JSON.parse(JSON.parse(this.props.state.entityViews.filter(x => x.key === key)[0].text).layoutjson).Rows[0].Cells :
            [];

        store.dispatch({
            type: types.SET_IS_PROPERTY_CHANGED,
            value: true
        });

        store.dispatch({
            type: types.SET_CONTROL_ENTITY_VIEW_COLUMNS,
            entityViewColumns: selectedLayoutView
        })

    }

    loadEntityForms = (name: string): Promise<any> => {

        let promise = new Promise<IControl>((resolve, reject) => {
            if (this.props.entityFields && this.props.entityFields[name]) {
                resolve(clone(this.props.entityFields[name]));
            }
            else {
                // add loading to true
                // store.dispatch({
                //     type: types.SET_ARE_ENTITY_FORMS_LOADING,
                //     value: true
                // });

                return ControlHelper.loadEntityForms(name)
                    .then(entityViews => {

                        // set loading to false
                        // store.dispatch({
                        //     type: types.SET_ARE_ENTITY_FORMS_LOADING,
                        //     value: false
                        // });

                        // let test = JSON.parse(this.props.state.entityViews.filter(x => x.key === key)[0].text);
                        // const selectedLayoutView = JSON.parse(this.props.state.entityViews.filter(x => x.key === key)[0].text).layoutjson ?
                        //     JSON.parse(JSON.parse(this.props.state.entityViews.filter(x => x.key === key)[0].text).layoutjson).Rows[0].Cells :
                        //     [];

                        // store.dispatch({
                        //     type: types.SET_IS_PROPERTY_CHANGED,
                        //     value: true
                        // });

                        // store.dispatch({
                        //     type: types.SET_CONTROL_ENTITY_VIEW_COLUMNS,
                        //     entityViewColumns: selectedLayoutView
                        // })


                        resolve(entityViews)
                    });
            }
        });

        return promise;
    }

    loadEntityViews = (name: string): Promise<any> => {

        let promise = new Promise<IControl>((resolve, reject) => {
            if (this.props.entityFields && this.props.entityFields[name]) {
                resolve(clone(this.props.entityFields[name]));
            }
            else {
                return ControlHelper.loadEntityViews(name)
                    .then(entityViews => {
                        let test = entityViews;
                        console.log('entityViews --->', entityViews);
                        resolve(entityViews)
                    });
            }
        });

        return promise;
    }


    // Update properties for action with Create Record option
    updateEntityProperty = (key: string, value: any) => {

        store.dispatch({
            type: types.SET_IS_PROPERTY_CHANGED,
            value: true
        });

        let previousLabel = PropertyHelper.getPropertyValue(this.props.state.control.Properties, 'Label');
        let control = PropertyHelper.updateProperty(this.props.state.control, key, value);
        PropertyHelper.resolveAdjustedFields(control.Properties, this.props.propertyFilters, key, value, true);

        if (control.OutputValues) {
            let primaryOutput = control.OutputValues[0];

            if (key === 'Label' && ActionHelper.shouldOverwriteOutputName(primaryOutput.Name, previousLabel)) {
                control.OutputValues[0].Name = value;
            }
        }

        // // If the changed value comes from Entity Name field, fetch necessary fields for the selected entity name.
        // // Store the fields in the state to update the values in the Fields Name dropdown.
        // if (key === 'Entity Name') {
        //     this.loadEntityFields(value, this.props.state.componentId)
        //     // this.loadEntityViews(value)
        //     this.setEntityOutput(action, value);
        // }

        // // Update state action along with fieldConfigs
        // store.dispatch({
        //     type: types.UPDATE_ACTION_ENTITY_DIALOG,
        //     action: action
        // });
    }


    // Update field property for the quick create form
    updateFormField = (formId: string, controlId: string, propertyName: string, value: any) => {

        store.dispatch({
            type: types.SET_IS_PROPERTY_CHANGED,
            value: true
        });

        // let formId = "";
        // let controlId = "";

        store.dispatch({
            type: types.UPDATE_FORM_FIELD_VALUE,
            formId: formId,
            controlId: controlId,
            propertyName: propertyName,
            value: value
        });

    }

    loadEntityFields = (name: string, componentId: string): Promise<any> => {

        let promise = new Promise<IControl>((resolve, reject) => {
            if (this.props.entityFields && this.props.entityFields[name]) {
                resolve(clone(this.props.entityFields[name]));
            }
            else {
                return ControlHelper.loadEntityFields(name, componentId)
                    .then(entityFields => {
                        resolve(entityFields)
                    });
            }
        });

        return promise;
    }


    public render() {

        let { previousOutputBlocks, componentId } = this.props.state;
        let { operators, operatorTypes } = this.props.cache;
        let { changeShowBlockContent, changeShowBlockTabs, isNewBlock, changeShowNewBlock, changeCurrentControlIndex } = this.props;
        let parentLoopId = this.props.parentLoopId;

        let outputOptions: IDropdownOption[] = OutputsHelper.getOutputDropdownOptions(this.props.outputs, previousOutputBlocks);
        let globalOutputDropdownOptions: IDropdownOption[] = OutputsHelper.getGlobalOutputDropdownOptions(this.props.outputs);

        if (parentLoopId) {
            // get loop Ids
            let loopOutputs: IOutputValue[] = this.props.outputs.filter((o: IOutputValue) => {
                return o.componentId === parentLoopId;
            });
            if (loopOutputs.length) {
                globalOutputDropdownOptions = globalOutputDropdownOptions.concat(loopOutputs.map(o => { return { key: o.Id, text: o.Name } }));
            }
        }
        // const isNewBlock = this.props.isNewBlock ? this.props.isNewBlock : false;
        return (
            <ControlConfig
                control={this.props.state.control}
                isRepeatableBlock={this.props.state.isRepeatableBlock}
                overIndex={this.props.state.overIndex}
                fromIndex={this.props.state.fromIndex}
                fieldConfigs={this.props.state.fieldConfigs}
                entityViews={this.props.state.entityViews}
                entityForms={this.props.state.entityForms}
                entityViewColumns={this.props.state.entityViewColumns}
                entityFormattedAttributes={this.props.state.entityFormattedAttributes}
                controlTypes={this.props.controlTypes}
                change={this.updateProperty}
                updateFormField={this.updateFormField}
                updateEntityProperty={this.updateEntityProperty}
                changeEntityForm={this.changeEntityForm}
                changeEntityView={this.changeEntityView}
                changeEntityViewColumn={this.changeEntityViewColumn}
                closeDialog={this.closeDialog}
                deleteControl={this.deleteControl}
                dropdownChange={this.dropdownChange}
                onLoad={this.onLoad}
                isControlTypeDropdownDisabled={this.isControlTypeDropdownDisabled}
                isDeleteButtonDisabled={this.isDeleteButtonDisabled}
                operators={operators}
                operatorTypes={operatorTypes}
                outputOptions={outputOptions}
                globalOutputDropdownOptions={globalOutputDropdownOptions}
                optionHandler={this.optionHandler}
                itemHandler={this.itemHandler}
                updateOutput={this.updateControlOutput}
                outputBlur={this.controlOutputBlur}
                updateSelectedGlobalOutput={this.updateSelectedGlobalOutput}
                updateOutputLogicalName={this.updateControlOutputLogicalName}
                setAdvancedSettingsIndex={this.setAdvancedSettingsIndex}
                advancedSettingsIndex={this.props.state.advancedSettingsIndex}
                updateOutputDefaultValue={this.updateOutputDefaultValue}
                validationEditIndex={this.props.state.validationEditIndex}
                editedValidationItem={this.props.state.editedValidationItem}
                updateEditedValidationItem={this.updateEditedValidationItem}
                setValidationEditIndex={this.setValidationEditIndex}
                showPivotErrorMessage={this.showPivotErrorMessage}
                hasErrors={this.props.modalErrorMessages && this.props.modalErrorMessages.length}
                showBlockContent={this.props.showBlockContent}
                changeShowBlockContent={changeShowBlockContent}
                changeCurrentControlIndex={changeCurrentControlIndex}
                // changeShowBlockContent={this.changeShowBlockContent}
                showBlockTabs={this.props.showBlockTabs}
                changeShowBlockTabs={changeShowBlockTabs}
                changeShowNewBlock={changeShowNewBlock}
                isNewBlock={isNewBlock}
                addNewLayoutPanel={this.props.addNewLayoutPanel}
                componentId={componentId}
                areEntityFormsLoading={this.props.state.areEntityFormsLoading}
                areEntityViewsLoading={this.props.state.areEntityViewsLoading}
            />
        );
    }

}

let mapStateToProps = (store) => {

    let component: IComponent = store.processState.components[store.modalState.controlConfig.componentId];
    // let parentLoopId: string = component.ParentLoopId;
    let parentLoopId: string = null;

    let outputs: IOutputValue[] = OutputsHelper.combineOutputs(store.outputsState.outputs, store.outputsState.globalOutputs, parentLoopId);

    return {
        modalErrorMessages: store.modalState.modal.errorMessages,
        state: store.modalState.controlConfig,
        controlTemplates: store.cacheState.controlTemplates,
        controlTypes: store.cacheState.controlTypes,
        outputs: outputs,
        outputLookupContext: store.outputsState.outputLookupContext,
        outputSearchElementId: store.outputsState.outputSearchElementId,
        outputSearchTerm: store.outputsState.outputSearchTerm,
        cache: store.cacheState,
        isSharedJourney: store.toolsState.isSharedJourney,
        parentLoopId: parentLoopId,
        component: component
    };
};

export default connect<any, any, any>(mapStateToProps)(ControlConfigContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/control-config.tsx